import React from "react";
import Quotations from "layouts/quotations";
import Orders from "layouts/orders";
import Options from "layouts/options";
import Export from "layouts/export";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import QuotationsDetails from "layouts/quotationsDetails";
import OrdersDetails from "layouts/ordersDetails";
import ResetPassword from "layouts/authentication/reset-password/cover";
import DefinePassword from "layouts/authentication/reset-password/definePassword.js";
import PrivacyConsent from "layouts/authentication/privacy-consent";
import PrivacyPolicy from "layouts/authentication/privacy-policy";
import AccessQuotation from "layouts/quotationsDetails/access-quotations";
import AccessOrder from "layouts/ordersDetails/access-orders";
import Icon from "@mui/material/Icon";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import LandingPage from "layouts/landingPage";
import Administrator from "layouts/administrator";

import ProtectedRoute from "./ProtectedRoute";


const routes = [
  {
    type: "route",
    name: "Login",
    key: "login",
    route: "/login",
    component: <SignIn />,
  },
  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    route: "/sign-up",
    component: <SignUp />,
  },
  {
    type: "route",
    name: "Consentimento de Privacidade",
    key: "privacy-consent",
    route: "/consentimento-privacidade",
    component: <PrivacyConsent />,
  },
  {
    type: "route",
    name: "Política de Privacidade",
    key: "privacy-policy",
    route: "/politica-privacidade",
    component: <PrivacyPolicy />,
  },
  {
    type: "collapse",
    name: "Ofertas",
    key: "ofertas",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/ofertas",
    component: (
      <ProtectedRoute>
        <Quotations />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Pedidos",
    key: "Pedidos",
    icon: <Icon fontSize="small">shopping_cart_checkout</Icon>,
    route: "/pedidos",
    component: (
      <ProtectedRoute>
        <Orders />
      </ProtectedRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Usuários",
  //   key: "usuarios",
  //   icon: <Icon fontSize="small">people</Icon>,
  //   route: "/usuarios",
  //   component: <Users />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notificações",
  //   key: "notifys",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <ProtectedRoute><Notifications /></ProtectedRoute>,
  // },
  {
    type: "collapse",
    name: "Exportar",
    key: "Exportar",
    icon: <FileDownloadOutlinedIcon fontSize="small" />,
    route: "/exportar",
    component: (
      <ProtectedRoute>
        <Export />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Opções",
    key: "opcoes",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/opcoes",
    component: <Options />,
  },
  {
    type: "route",
    name: "Detalhes Ofertas",
    key: "oferta-detalhes",
    route: "/ofertas/:id",
    component: <QuotationsDetails />,
  },
  {
    type: "route",
    name: "Detalhes Pedidos",
    key: "pedido-detalhes",
    route: "/pedidos/:id",
    component: <OrdersDetails />,
  },
  {
    type: "route",
    name: "Redefinir Senha",
    key: "reset-password",
    route: "/reset-password",
    component: <ResetPassword />,
  },
  {
    type: "route",
    name: "Definir Senha",
    key: "define-password",
    route: "/define-password/:id",
    component: <DefinePassword />,
  },
  {
    type: "route",
    name: "Acessar Oferta",
    key: "access-quotation",
    route: "/access-quotation/:guid",
    component: <AccessQuotation />,
  },
  {
    type: "route",
    name: "Acessar Pedido",
    key: "access-order",
    route: "/access-order/:guid",
    component: <AccessOrder />,
  },
  {
    type: "route",
    name: "Landing Page",
    key: "landing-page",
    route: "/landing-page",
    component: <LandingPage />,
  },
  {
    type: "collapse",
    name: "Administração",
    key: "administrador",
    icon: <AdminPanelSettingsIcon fontSize="small" />,
    route: "/administrator",
    component: (
      <ProtectedRoute>
        <Administrator />
      </ProtectedRoute>
    ),
  },
];

export default routes;